import { useEffect } from 'react'

import { withStyles, WithStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { RootState } from 'store/store'

import { checkConnection } from '../../../../../../../services/root/root-service'
import { PickerOrganization } from '../../../../../services/locationPicker-service'
import deviceDetailsActions from '../../../services/deviceDetails-actions'
import styles from './style'

type OwnProps = {
  value: PickerOrganization | null
  onChange: (organization: PickerOrganization | null) => void
  disabled?: boolean
}

type OrganizationSelectProps = OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  WithStyles<typeof styles>

const OrganizationSelect = ({
  classes,
  organizations,
  value,
  onChange,
  loadOrganizationsForPicker,
  disabled = false,
}: OrganizationSelectProps) => {
  useEffect(() => {
    loadOrganizationsForPicker()
  }, [loadOrganizationsForPicker])

  return (
    <Autocomplete
      className={classes.organizationField}
      options={organizations}
      value={value}
      onChange={(_event, organization) => onChange(organization)}
      getOptionLabel={(option) => option.name}
      getOptionSelected={(option, selected) => option.id === selected.id}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Organization (optional)"
          variant="outlined"
          margin="normal"
        />
      )}
    />
  )
}

const mapStateToProps = (state: RootState) => ({
  organizations: state.devicesReducer.deviceDetailsReducer.pickerOrganizations,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loadOrganizationsForPicker: () =>
    dispatch(
      checkConnection(() => deviceDetailsActions.loadOrganizationsForPicker())
    ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(OrganizationSelect))
